import React from 'react'
import { useAppDispatch } from 'app/hooks'
import Lightbox from 'components/visualization/Lightbox'
import { useLightboxInfo } from 'hooks/useUiState'
import { closeLightbox } from 'features/ui/uiSlice'
import { useTranslation } from 'react-i18next'

const LightboxHandler = () => {
  const dispatch = useAppDispatch()
  const lightboxInfo = useLightboxInfo()
  const { t } = useTranslation()

  return (
    <Lightbox
      isOpen={lightboxInfo.isOpen}
      slides={lightboxInfo.slides}
      defaultIndex={lightboxInfo.defaultIndex}
      onClose={() => dispatch(closeLightbox())}
      placeholders={{
        video: {
          description: t('videoNotAvailable'),
          link: {
            str: t('moreThreeDot'),
            herf: 'https://help.quid.com/articles/8240236#h_24b221c46b'
          }
        },
        image: {
          description: t('imageNotAvailable'),
          link: {
            str: t('moreThreeDot'),
            herf: 'https://help.quid.com/articles/8240236#h_24b221c46b'
          }
        }
      }}
    />
  )
}

export default LightboxHandler
